import { render } from "./socialTile.vue?vue&type=template&id=46092a8e&scoped=true"
import script from "./socialTile.vue?vue&type=script&lang=js"
export * from "./socialTile.vue?vue&type=script&lang=js"

import "./socialTile.vue?vue&type=style&index=0&id=46092a8e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46092a8e"]])

export default __exports__